import { render, staticRenderFns } from "./PopupUnavailableProducts.vue?vue&type=template&id=08144a6b&"
import script from "./PopupUnavailableProducts.vue?vue&type=script&lang=js&"
export * from "./PopupUnavailableProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports